export function isMenuAccessible(urlPath) {
    const menuObj = JSON.parse(sessionStorage.getItem('menu'))
    if (menuObj) {
        const ret = menuObj.some(menu => {
            if (menu.pageUrl.startsWith(urlPath)) {
                return true
            }
        })
        if (ret) {
            return true
        }
    }
    return false
    // return true
}

export function isSubMenuAccessible(urlPath) {
    const menuObj = JSON.parse(sessionStorage.getItem('menu'))
    if (menuObj) {
        const ret = menuObj.some(menu => {
            if (menu.pageUrl === urlPath) {
                return true
            }
        })
        if (ret) {
            return true
        }
    }
    return false
    // return true
}

export function firstMenu() {
    if (sessionStorage.getItem('menu')) {
        if (JSON.parse(sessionStorage.getItem('menu')).length > 0) {
            let pageUrl = []
            JSON.parse(sessionStorage.getItem('menu')).forEach(item => {
                pageUrl.push(item)
            })
            if (pageUrl.length > 0) {
                // console.info("firstMenu:" + pageUrl[0].pageUrl);
                return pageUrl[0].pageUrl
            } else {
                return '/error'
            }
        }
    }
    return '';
}
